<template>
    <div class="content-box">
        <Title/>

        <div v-loading="loading">
            <div class="text">
                <a
                v-for="(i, index) in text"
                :key="index"
                :href="'/detail--' + i.id + '.html'"
                target="_blank">
                    <div class="img">
                        <el-image v-if="index <= 40" :src="require('@/assets/' + index + '.jpg')" lazy></el-image>
                        <el-image v-else :src="require('@/assets/' + (index % 40) + '.jpg')" lazy></el-image>
                    </div>
                    <div class="con">
                        <span>{{ i.title }}</span>
                        <p>{{ i.post_date.split(/T|Z/).join(' ') }}</p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "interview",
    data() {
        return {
            text: [],
            loading: false,
        }
    },
    mounted() {
        this.broadCast()
    },
    methods: {
        broadCast() {
            this.loading = true
            axios.get('/searchjson.html?p=1&n=1000&terms=电商访谈')
            .then((res) => {
                this.loading = false
                for(var i of res.data.list) {
                    if (i.keyword[0].indexOf('跨境') != -1) {
                        this.text.push(i)
                    }
                }
            });
        },
    },
};
</script>